/**
 * Section headers inside cards. Distinct from page titles (2xl semibold)
 * and body copy (sm) — small uppercase labels create a clear third level.
 */
export const sectionTitleClass =
  "text-xs font-medium uppercase tracking-wider text-muted-foreground";
